import React, { Component } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';

import { locale, addLocale } from 'primereact/api';
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import 'primeicons/primeicons.css';

import Login from './pages/sistema/Login';
import RecuperarSenha from './pages/sistema/RecuperarSenha';
import Profissional from './pages/sistema/Profissional';
import Condominio from './pages/sistema/Condominio';
import CondominioDetalhe from './pages/sistema/CondominioDetalhe';
import Documentos from './pages/sistema/Documentos';
import ProfissionalDetalhe from './pages/sistema/ProfissionalDetalhe';
import Hotsite from './pages/hotsite/Hotsite';
import PoliticaPrivacidade from './pages/hotsite/PoliticaDePrivacidade';
import TermoUso from './pages/hotsite/TermodeUso';
import PerfilPg from './pages/sistema/Perfil';
import PaginaError from './pages/hotsite/PaginaError';
import DocumentoDetalhe from './pages/sistema/DocumentoDetalhe';


/* Alterando lingua de en pra pt calendario */
addLocale('br', {
  firstDayOfWeek: 1,
  dayNames: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
  dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
  dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
  monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
  monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
  today: 'Hoje',
  clear: 'Limpar'
});

locale('br');

class Rota extends Component {
  render() {
    const path = window.location.pathname;
    let component;

    switch (path) {
      case '/':
        component = <Hotsite />;
        break;

      case '/hotsite':
        component = <Hotsite />;
        break;

      case '/sistema/login':
        component = <Login />;
        break;

      case '/sistema/recuperar_senha':
        component = <RecuperarSenha />;
        break;

      case '/sistema/profissionais':
        component = <Profissional />;
        break;

      case '/sistema/profissional_detalhe':
        component = <ProfissionalDetalhe />;
        break;

      case '/sistema/condominio':
        component = <Condominio />;
        break;

      case '/sistema/documentos':
        component = <Documentos />
        break;

      case '/sistema/documento_detalhe':
        component = <DocumentoDetalhe />
        break;

      case '/sistema/condominio_detalhe':
        component = <CondominioDetalhe />;
        break;

      case '/sistema/perfil':
        component = <PerfilPg />;
        break;

      case '/hotsite/politica_de_privacidade':
        component = <PoliticaPrivacidade />;
        break;

      case '/hotsite/termos_de_uso':
        component = <TermoUso />;
        break;
      default:
        component = <PaginaError />;
        break;
    }
    return (
      <div>
        {component}
      </div>
    );
  }
}


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<Rota />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
